class EventDispatcher{
    
    static EVENT_LOADED='loaded';
    static EVENT_LOAD_ERROR='loadError';
    static EVENT_LOADING='loading';
    static EVENT_OPEN='open';
    static EVENT_OPENED='opened';
    static EVENT_CLOSE='close';
    static EVENT_CLOSED='closed';
    static EVENT_CHANGING='changing';
    static EVENT_CHANGED='changed';
    static EVENT_COMPLETE='complete';
    static EVENT_SELECTED='selected';
    static EVENT_ANIMATION_COMPLETE='animationComplete';
    static EVENT_OVER='over';
    static EVENT_OUT='out';
    static EVENT_CLICK='click';
    static EVENT_EMPTY='empty';
    static EVENT_START='start';
    static EVENT_NOTIFICATION='notification';
    static EVENT_CONTINUE='continue';
    static EVENT_BACK='back';
    
    _listeners=null;
    
    addEventListener(type,listener){
        let listeners=this._listeners=this._listeners || [];
        if (!listeners[type]) listeners[type]=[];
        listeners[type].push(listener);

        return listener;
    }
    
    removeEventListener(type,listener){
        let listeners=this._listeners;
        if (!listeners) return;
        var arr=listeners[type];
        if (!arr) return;
        if (listener){
            for (var i=0,l=arr.length;i<l;i++){
                if (arr[i]==listener){
                    if (l==1) delete(listeners[type]);
                    else arr.splice(i,1);
                    break;
                }
            }
        }else{
            delete(listeners[type]);
        }
    }
    
    //dispatchEvent(type,args){
    dispatchEvent(event){
        let listeners=this._listeners;
        if (!listeners) return;
        let type=event.type;
        let arr=listeners[type];
        if (!arr) return;
        arr=arr.slice();
        for (var i=0,l=arr.length;i<l;i++){
            if (arr[i]){
                let func=arr[i];
                //func.call(this,args);
                func.call(this,event);
            }
        }
    }
}

export {EventDispatcher};